import humps from 'lodash-humps-ts';
import { snakes } from '@utils/lodash';
import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { NumericString, WithParams } from '@utils/typescript';
import { HealthClaimCostItem } from '@models/HealthClaimCostItem';

export type CreateHealthClaimCostItemParams = WithParams<{
  health_claim_id: number;
  benefit_limit_id: number;
  declared_amount: NumericString;
  declined_amount: NumericString;
  deductible_copay_amount: NumericString;
  over_limit_amount: NumericString;
  custom_sub_benefit?: string | '';
  remark?: string | '';
}>;

export type GetAllHealthClaimCostItemParams = { healthClaimId: number };
export type UpdateHealthClaimCostItemParams = Omit<CreateHealthClaimCostItemParams, 'healthClaimId'> & WithParams<{ id: number }>;
export type ApproveAllHealthClaimCostItemParams = GetAllHealthClaimCostItemParams;
export type DeleteHealthClaimCostItemParams = { id: number };

export class HealthClaimCostItemApi {
  static create = async ({ benefitLimitId, ...rest }: CreateHealthClaimCostItemParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/user/health_claim_cost_items`, benefitLimitId ? snakes({ benefitLimitId, ...rest }) : snakes(rest))
      .then((response) => humps(response.data) as HealthClaimCostItem);
  };

  static getAll = async (params: GetAllHealthClaimCostItemParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/health_claim_cost_items`, { params: snakes(params) })
      .then((response) => humps(response.data) as HealthClaimCostItem[])
  }

  static update = async ({ id, benefitLimitId, ...rest }: UpdateHealthClaimCostItemParams) => {
    return await authAxios
      .put(`${API_V1_BASE}/user/health_claim_cost_items/${id}`, benefitLimitId ? snakes({ benefitLimitId, ...rest }) : snakes(rest))
      .then((response) => humps(response.data) as HealthClaimCostItem)
  };

  static approveAll = async (params: ApproveAllHealthClaimCostItemParams) => {
    return await authAxios
      .put(`${API_V1_BASE}/user/health_claim_cost_items/approve`, snakes(params))
      .then((response) => humps(response.data) as HealthClaimCostItem[])
  };

  static delete = async ({ id }: DeleteHealthClaimCostItemParams) => {
    return await authAxios.delete(`${API_V1_BASE}/user/health_claim_cost_items/${id}`).then((response) => humps(response.data) as HealthClaimCostItem);
  };
}
